import Portal from '@reach/portal';
import PropTypes from 'prop-types';
import { cssTransition, ToastContainer } from 'react-toastify';

import { CloseButton } from 'Buttons';

import './styles/toasterStyles.css';

const slide = cssTransition({
  enter: 'slide-in',
  exit: 'slide-out',
});

const ToastCloseButton = ({ closeToast }) => (
  <CloseButton
    callback={closeToast}
    className="absolute right-4 top-2 text-xl"
  />
);

ToastCloseButton.propTypes = {
  closeToast: PropTypes.func.isRequired,
};

const Toaster = () => {
  return (
    <Portal>
      <ToastContainer
        className="fixed bottom-16 right-8 z-notifications toaster Toastify__toast Toastify__progress-bar"
        closeButton={ToastCloseButton}
        closeOnClick={false}
        limit={6}
        newestOnTop
        transition={slide}
      />
    </Portal>
  );
};

export default Toaster;
